import React, {useEffect, useState} from "react";
import Spinner from "../../../spinner";
import {Col, Table} from "antd";
import {tableHelper} from "../../../../helpers";
import {consignorService} from "../../../../services";
import i18n from "../../../../i18n";

export default function Consignors() {
  const [loading, setLoading] = useState(false);
  const [isNeedUpdateConsignors, setIsNeedUpdateConsignors] = useState(false);
  // const [showModalCreateConsignor, setShowModalCreateConsignor] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [consignorsData, setConsignorsData] = useState(null);

  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateConsignors(true);
    }
  }, [isNeedUpdateConsignors]);

  if (isNeedUpdateConsignors) {
    consignorService
      .getConsignorsList()
      .then((response) => {
        let reindexedTableData = [];
        response.forEach((item) => {
          reindexedTableData.push({
            name: item.Name,
            id: item.Id,
            dateCreated: item.DateCreated,
            isOwner: item.IsOwner ? i18n.t('main.yes') : i18n.t('main.no'),
          });
        });

        setConsignorsData(reindexedTableData);
        setIsNeedUpdateConsignors(false);
        setLoading(false);
      })
      .catch((errorMsg) => {
        setIsNeedUpdateConsignors(false);
        setErrorMsg(errorMsg);
        setLoading(false);
      });
  }

  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  const columns = [
    {
      title: i18n.t('settingsPage.consignors.table.name.title'),
      dataIndex: "name",
      key: "name",
      width: "30%",
      ...tableHelper.getColumnSearchProps("name", searchText, setSearchText),
    },
    {
      title: i18n.t('settingsPage.consignors.table.isOwner.title'),
      dataIndex: "isOwner",
      key: "isOwner",
      width: "30%",
      ...tableHelper.getColumnSearchProps("isOwner", searchText, setSearchText),
    },
    {
      title: i18n.t('settingsPage.consignors.table.date.title'),
      dataIndex: "dateCreated",
      key: "dateCreated",
      width: "30%",
      ...tableHelper.getColumnSearchProps("dateCreated", searchText, setSearchText),
    },
  ];
  return (
    <React.Fragment>
      <h1 className="content-header">{i18n.t('settingsPage.consignors.title')}</h1>
      {/*<Row gutter={48} style={{ paddingRight: "0" }}>*/}
      {/*  <Col span={24} style={{ textAlign: "right", height: "40px", marginBottom: "24px" }}>*/}
      {/*    <Button*/}
      {/*      type="primary"*/}
      {/*      htmlType="button"*/}
      {/*      onClick={() => {*/}
      {/*        setShowModalCreateConsignor(true);*/}
      {/*      }}*/}
      {/*      style={{ backgroundColor: "#1CAA53", border: "none", height: "100%" }}*/}
      {/*    >*/}
      {/*      Добавить Грузоотправителя*/}
      {/*    </Button>*/}
      {/*    <ModalCreateConsignor isShow={showModalCreateConsignor} setIsShow={setShowModalCreateConsignor} />*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Col span={24}>
        <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
          <Table
            style={{minWidth: "700px"}}
            columns={columns}
            dataSource={consignorsData}
            locale={{emptyText: i18n.t('main.empty')}}
            rowKey="name"
            size="small"
            pagination={{
              pageSize: 50,
            }}
          />
        </Spinner>
      </Col>
    </React.Fragment>
  );
}
